<template>
  <div>
    <b-button
      id="comments-btn"
      variant="primary"
      :v-b-toggle="commentUrl"
      :aria-controls="commentUrl"
      :aria-expanded="this.showCollapse ? 'true' : 'false'"
      @click="toggleClick"
    >
      <i class="fa fa-comment"></i>
    </b-button>
    <b-collapse
      :id="commentUrl"
      v-model="showCollapse"
      class="mt-2"
    >
      <div class="input-for-comment">
        <input
          v-model="postComment"
          type="text"
          placeholder="Add a comment..."
        >
        <UploadImg/>
      </div>
      <div>
        <button
          v-if="postComment.length"
          v-on:click="commOncomm"
        >Post</button>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import UploadImg from './UploadImg.vue';

export default {
  props: {
    commentUrl: {
      type: String,
      default: '',
    },
    post: {
      type: String,
      default: '',
    },
  },
  components: {
    UploadImg,
  },
  data() {
    return {
      showCollapse: false,
      postComment: '',
    };
  },
  methods: {
    ...mapActions({
      addComment: 'comments/addComment',
    }),
    toggleClick() {
      this.showCollapse = !this.showCollapse;
    },
    async commOncomm() {
      if (this.postComment.length) {
        const comment = await this.addComment({
          content: this.postComment,
          post: this.post,
          parent_comment: this.commentUrl,
        });
        this.postComment = '';
        this.showCollapse = false;
        this.$emit('comment-retrieved', comment.data);
      }
    },
  },
};
</script>

<style scoped>
.commentOnComment {
  border: 1px solid black;
}
#comments-btn {
  background: #faebd700;
  border: unset;
  color: #333333;
  font-size: 14px;
  margin-top: -9px;
  box-shadow: none;
  margin: -6px 0px 0px 16px;
}
#comments-btn:hover {
  color: #BD9D5F;
  transition: 0.5s;
}

</style>
